import { AxiosResponse } from 'axios';

import { api } from '../../http';

import { CustomTaskExportSetting } from './interfaces/CustomTaskExportSetting';

export const CustomTaskExportSettingsService = {
  // Получение списка личных шаблонов (по текущему пользователю)
  getPersonalTemplates(): Promise<AxiosResponse<CustomTaskExportSetting[]>> {
    return api.get<CustomTaskExportSetting[]>(
      'customTaskExportSetting/getByUser'
    );
  },

  // Получение списка общих шаблонов (не привязанных к пользователю)
  getSharedTemplates(): Promise<AxiosResponse<CustomTaskExportSetting[]>> {
    return api.get<CustomTaskExportSetting[]>(
      'customTaskExportSetting/getWithoutUser'
    );
  },

  // Создание (или обновление) шаблона
  // При создании можно не передавать Id, или передавать Id=0
  // При обновлении нужно передать Id > 0.
  createOrUpdateTemplate(
    template: CustomTaskExportSetting
  ): Promise<AxiosResponse> {
    return api.post('customTaskExportSetting/', template);
  },

  // Удаление шаблона
  deleteTemplate(id: number): Promise<AxiosResponse> {
    return api.delete(`customTaskExportSetting/${id}`);
  },

  // Получение конкретного шаблона по Id (если нужно)
  getTemplateById(id: number): Promise<AxiosResponse<CustomTaskExportSetting>> {
    return api.get<CustomTaskExportSetting>(`customTaskExportSetting/${id}`);
  }
};
